import React from "react";
import { PROGRAM_SPECIFIC_NAMES } from "../../Helpers/constants";
import { getSupportCaseLink } from "../../Helpers/utils";
import { resolveTemplateExternalHref } from "../Common/StandaloneFormViews/resolveExternalHref";
import DxpPageShell from "../Common/StandaloneFormViews/DxpPageShell";
import {
  DxpBodyText,
  DxpHeading,
  DxpMessageCard,
  DxpNarrowColumn,
  DxpInlineLink,
} from "../dxpStandaloneUi";
import DxpRegistrationTopHeader from "../DxpRegistrationTopHeader";

const PROGRAM = "DXP";

function RegistrationPendingMessage({ appType }: { appType?: string }) {
  const { title } = PROGRAM_SPECIFIC_NAMES.DXP.partnerProgram;
  const aemHref = resolveTemplateExternalHref({
    endpointPath: "environment.aemHomePageUrl",
    redirect: { type: "external", path: "/digitalexperience/" },
  });

  return (
    <>
      <DxpRegistrationTopHeader program={PROGRAM} />

      <DxpPageShell appType={appType} requireCommonHeaders>
        <div className="dxp-static-message-outer">
          <DxpNarrowColumn>
            <DxpMessageCard className="dxp-message-card--min-h-350">
              <DxpHeading>
                Your Adobe {title} application is under review.
              </DxpHeading>
              <DxpBodyText className="dxp-body-text--bold dxp-body-text--fs-18">
                Registration process is in progress.
              </DxpBodyText>
              <p className="dxp-body-text dxp-mt-10 dxp-body-text--spacing-tight">
                If you feel you are receiving this message in error, please{" "}
                <DxpInlineLink
                  href={getSupportCaseLink()}
                  label="contact support"
                  newTab
                />
                <span>.</span>
              </p>
              <div className="dxp-standalone-footer-bordered">
                {aemHref ? (
                  <DxpInlineLink
                    href={aemHref}
                    label="Go to Digital Experience Partner Program home page"
                    newTab
                  />
                ) : null}
              </div>
            </DxpMessageCard>
          </DxpNarrowColumn>
        </div>
      </DxpPageShell>
    </>
  );
}

export default RegistrationPendingMessage;
